import { createTheme } from '@material-ui/core';

export const VendorAreaTheme = createTheme({});
